module.exports = __webpack_public_path__ + "assets/img/New Science Ctr_Stargazing_RGB_hr.0aa1ecbb.png";